<template>
	<div
		:class="['list-item-wrapper', { 'open': isActive }]"
		v-on="events"
	>
		<Vector
			:class="['meter-icon', { 'low-score': lowScore }]"
			:src="meter_icon"
			:style="meterTransformCss"
		/>
		<slot></slot>
		<div class="meter-label">{{ title }}</div>
		<Tooltip class="tooltip" :title="title" :info="info" />
	</div>
</template>

<script>
import Tooltip from "@/components/base/Tooltip";
import Vector from "@/components/base/Vector";

export default {
	name: 'Meter',
	components: {
		Tooltip,
		Vector,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		meter_icon: {
			type: String,
			required: true,
		},
		value: {
			type: Number,
			required: true,
		},
		info: {
			type: String,
			required: true,
		},
	},
	computed: {
		meterPercent() {
			return Math.max((1 - this.value) * 100, 0);
		},
		meterTransformCss() {
			return {
				"--meter-translate-value": `${this.meterPercent}%`,
			};
		},
		lowScore() {
			return this.meterPercent >= 75;
		},
		events() {
			const desktop = window.screen.width >= 1366;
			return {
				...(!desktop && { click: this.toggleOpen }),
				...(desktop && { mouseenter: this.toggleOpen }),
				...(desktop && { mouseleave: this.toggleOpen }),
			};
		},
	},
	data() {
		return {
			isActive: false,
		};
	},
	methods: {
		toggleOpen() {
			this.isActive = !this.isActive;
		},
	},
};
</script>

<style lang="scss" scoped>
	.list-item-wrapper {
		position: relative;

		&.open {
			.tooltip {
				transform: translateX(0);
				box-shadow: $box-shadow;
				opacity: 1;
			}
		}
	}

	.meter-icon {
		width: 100%;
		padding: 3% 25%;

		@include tablet { padding: 20%; }
		@include desktop { padding: 15%; }
		@include desktop-sm { padding: 10% 20%; }

		/deep/ .progress {
			transform: translateY(var(--meter-translate-value, 50%));
			transition: all $ui-transition-duration;

			&.low-score { fill: $warning-color; }
		}

		&.low-score /deep/ .progress { fill: $warning-color; }
		.alt-color & /deep/ path:not(.progress) { fill: $background-color-dark; }
	}

	.meter-label { text-align: center; }

	.tooltip {
		transition: all $ui-transition-duration;
		transform: translateX(-100%);
		opacity: 0;
		z-index: -1;

		.alt-color & { display: none; }
	}
</style>



// WEBPACK FOOTER //
// src/components/game/sidebar/Meter.vue